module.exports = __webpack_public_path__ + "img/Lottery-Heritage-Fund.c7abe1cb.png";